import React, {useEffect, useImperativeHandle, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {Box, TextField, Typography} from "@mui/material";
import Row from "../../../Common/Row";
import {formatNumber} from "../../../../Utilities/postUtils";

export const PriceFilterDesktop = React.forwardRef((props, ref) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const priceParam = searchParams.get("price");

    const [min, setMin] = useState( "");
    const [max, setMax] = useState("");

    useImperativeHandle(ref, () => {
        return {
            onNewRange: onNewRange
        }
    });

    useEffect(() => {
        // If there is no price param
        if (priceParam == null) {
            setMin("");
            setMax("");
            return;
        }

        // If there is a price param, update the UI
        const price = priceParam.split(":");

        if (price.length > 0) {
            setMin(price[0]);
        }

        if (price.length > 1) {
            setMax(price[1]);
        }
    }, [priceParam]);

    // Returns an object specifying the new price range
    const onNewRange = () => {
        if (min == "" && max == "") return {}
        return {price: `${min}:${max}`}
    }

    const onEnter = (event) => {
        event.target.blur();

        // If both fields are empty
        if (min == "" && max == "") {
            searchParams.delete("price");
        } else {
            searchParams.set("price", `${min}:${max}`);
        }

        searchParams.delete("page");
        setSearchParams(searchParams);
    }

    return <Box>
        <Typography sx={{fontWeight: "bold"}}>Pris</Typography>
        <Row
            sx={{
                paddingTop: "10px",
                alignItems: "center",
            }}
        >
            <TextField
                sx={{maxWidth: "100px"}}
                label={"Fra"}
                value={min}
                onChange={(event) => {
                    setMin(formatNumber({
                        value: event.target.value,
                        useComma: false
                    }));
                }}
                onKeyUp={(event) => {
                    if (event.key === "Enter") {
                        onEnter(event);
                    }
                }}
            />
            <Typography
                sx={{padding: "0 5px"}}
            >-</Typography>
            <TextField
                sx={{maxWidth: "100px"}}
                label={"Til"}
                value={max}
                onChange={(event) => {
                    setMax(formatNumber({
                        value: event.target.value,
                        useComma: false
                    }));
                }}
                onKeyUp={(event) => {
                    if (event.key === "Enter") {
                        onEnter(event);
                    }
                }}
            />
        </Row>
    </Box>
});